import { render, staticRenderFns } from "./UserAvatar.vue?vue&type=template&id=c6fd4470&scoped=true"
import script from "./UserAvatar.ts?vue&type=script&lang=ts&external"
export * from "./UserAvatar.ts?vue&type=script&lang=ts&external"
import style0 from "./UserAvatar.scss?vue&type=style&index=0&id=c6fd4470&prod&lang=scss&scoped=true&external"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c6fd4470",
  null
  
)

export default component.exports